import React from 'react'
import { Form, Label,Row, FormText, Col,ListGroup,ListGroupItem} from 'reactstrap';
import './StyleReturnReason.css';

export const FormIndications = (props) => {

    const {

       loading, toggle,handleInputChange,methodAction,button,indication,validaciones

    }= props;

    const {
        
        indication_valid

    } = validaciones;

    return (
        <Form className="theme-form" role="form" onSubmit={methodAction}>
            
            <textarea
                rows={5}
                name="indication"
                value={indication}
                onChange={handleInputChange}
                className={`reason-textarea ${indication_valid ? "input-error" : ""}`}

                placeholder="Describe la indicación para el estudio del paciente..."
            />

            <Col md="12" className='text-center'>
                <FormText color="danger" hidden={!indication_valid} >Redacar las indicaciones</FormText>
            </Col>  
            
        </Form>
     
    )
}
